module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "teachers"
  }, _vm._l((_vm.list), function(teacher) {
    return _c('div', {
      key: teacher.id,
      staticClass: "teachers__item"
    }, [_c('div', {
      staticClass: "teachers__item-photo"
    }, [(teacher.photo) ? [_c('img', {
      staticClass: "teachers__item-image",
      attrs: {
        "src": teacher.photo
      }
    })] : [_c('div', {
      staticClass: "teachers__item-image",
      class: ("teachers__item-image-type-" + (teacher.image))
    })]], 2), _c('div', {
      staticClass: "teachers__item-description"
    }, [_c('div', {
      staticClass: "teachers__item-name"
    }, [_vm._v(_vm._s(teacher.fio))]), (teacher.progress) ? _c('div', {
      staticClass: "teachers__item-block teachers__item-block_column"
    }, [_c('div', {
      staticClass: "teachers__item-block-title"
    }, [_vm._v("Достижения:")]), _c('div', {
      staticClass: "teachers__item-block-value",
      domProps: {
        "innerHTML": _vm._s(teacher.progress)
      }
    })]) : _vm._e(), (teacher.groups && teacher.groups.length) ? _c('div', {
      staticClass: "teachers__item-block teachers__item-block_column"
    }, [_c('div', {
      staticClass: "teachers__item-block-title"
    }, [_vm._v("Группы:")]), _c('div', {
      staticClass: "teachers__item-block-value"
    }, _vm._l((teacher.groups), function(group, index) {
      return _c('div', {
        key: group.id,
        staticClass: "teachers__item-group"
      }, [_c('span', [_vm._v(_vm._s(group.name))]), (index !== teacher.groups.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
    }), 0)]) : _vm._e(), _c('a', {
      staticClass: "teachers__item-link",
      attrs: {
        "href": teacher.programsLink
      }
    }, [_vm._v("Посмотреть все программы педагога")])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2512605f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/teachers/Teachers.vue
// module id = e404fab78985cb5fea3b
// module chunks = 5